import { Link, useNavigate } from "react-router-dom";
import { HText, Header, Paragraph, Title } from "../components";
import { Footer } from "../components";

import heroImg from "../assets/images/mauro/mauro-inside-van.jpg";

import certifiedIcon from "../assets/icons/certified.svg";
import ecoFriendlyIcon from "../assets/icons/eco.svg";
import mobileServiceIcon from "../assets/icons/mobile-van.svg";

import styles from "./Home.module.css";
import { HomeServicesCarousel } from "../components/carousels/HomeServicesCarousel";

export const Home = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/contact");
  };

  return (
    <>
      <Header linksStyle="main" />
      <div className={styles.heroSection}>
        <img src={heroImg} alt="" className={styles.heroBackgroundImage} />
        <div className={styles.heroContent}>
          <div className={styles.bodyTitle}>
            <Title
              text="Your Gateway to Complete Automotive Care!"
              size={30}
              color={"#fff"}
            />
            <Paragraph
              color={"rgb(195, 195, 195)"}
              text="Expert Hydrogen Cleaning, Electrical, Mechanical & A/C Services to Keep Your Vehicle at Peak Performance."
            />
          </div>
          <button className={styles.ctaButtonHead} onClick={handleClick}>
            Book Now
          </button>
        </div>
      </div>

      <div className={styles.main}>
        <div className={styles.bodyContainer}>
          <div className={styles.bodyContent}>
            <div className={styles.bodyTopicTitle}>
              <HText text="Our Key Services" />
            </div>
            <div className={styles.bodyTopicSub}>
              <Paragraph text="At Massari Auto Service, we offer a comprehensive range of automotive services, including:" />
            </div>
            {/* Service Showcase - Styled as cards, ready for a carousel */}
            <HomeServicesCarousel />
            <HText text="Why Choose Massari Auto Service?" />
            <div className={styles.whyChooseUsGrid}>
              <div className={styles.whyChooseItem}>
                <img
                  src={certifiedIcon}
                  alt="Certified"
                  className={styles.whyChooseIcon}
                />
                <h4>Certified & Insured</h4>
                <p>
                  Peace of mind with fully qualified and insured professionals.
                </p>
              </div>
              <div className={styles.whyChooseItem}>
                <img
                  src={ecoFriendlyIcon}
                  alt="Eco-Friendly"
                  className={styles.whyChooseIcon}
                />
                <h4>Eco-Friendly Solutions</h4>
                <p>
                  Specializing in Hydrogen Engine Cleaning for reduced
                  emissions.
                </p>
              </div>
              <div className={styles.whyChooseItem}>
                <img
                  src={mobileServiceIcon}
                  alt="Mobile Service"
                  className={styles.whyChooseIcon}
                />
                <h4>Customer Focused</h4>
                <p>Dedicated to honest advice and high-quality workmanship.</p>
              </div>
            </div>

            <div className={styles.testimonialSnippet}>
              <HText text="What Our Customers Say" />
              <div className={styles.testimonialCard}>
                <p className={styles.testimonialText}>
                  "Mauro has Hydrocleaned my two cars and motorbike and I have
                  seen a huge improvement! Drives smoother, quieter and less
                  delay between gears. Excellent service and would reccomend to
                  anyone!"
                </p>
                <p className={styles.testimonialAuthor}>- Jake McCoull</p>
                <Link to="/reviews" className={styles.allReviewsLink}>
                  Read More Reviews
                </Link>
              </div>
            </div>

            <HText text="Experience Professional Auto Services!" />
            <Paragraph text="At Massari Auto Service, we believe in delivering comprehensive automotive care. Our services include hydrogen engine cleaning, electrical repairs, light mechanical work, and air-conditioning servicing. With our expertise as Heavy Duty Diesel Mechanics and Auto Electricians, we provide eco-friendly solutions alongside traditional services to keep your vehicle running at its best!" />
            <div
              onClick={() => navigate("/about")}
              className={styles.learnMore}
            >
              Learn more about us
            </div>
            <HText text={"Book Your Service Today!"} />
            <Paragraph
              text={
                "Ready to experience the Massari Auto Service difference? Book your automotive service today and ensure your vehicle is performing at its best!"
              }
            />
            <button className={styles.ctaButtonFooter} onClick={handleClick}>
              Book Now
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
